var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    transform: "translate(0 -0.399)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.399)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6,13.3A13.3,13.3,0,1,0,11.222,26.439V17.145H7.845V13.3h3.377V10.37c0-3.333,1.986-5.175,5.024-5.175a20.453,20.453,0,0,1,2.977.26V8.728H17.546a1.922,1.922,0,0,0-2.167,2.077V13.3h3.689l-.59,3.845h-3.1v9.294A13.3,13.3,0,0,0,26.6,13.3",
    fill: "#1877f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.632,211.949l.59-3.845h-3.689V205.61a1.922,1.922,0,0,1,2.167-2.077h1.677V200.26A20.453,20.453,0,0,0,310.4,200c-3.038,0-5.024,1.841-5.024,5.175v2.93H302v3.845h3.377v9.294a13.442,13.442,0,0,0,4.156,0v-9.294Z",
    transform: "translate(-294.155 -194.805)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.d98f7f7124b317be12852f2aaa65769a.svg";
export { ForwardRef as ReactComponent };